var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 113c3 4 3 9 0 12s-8 3-12 0L211 20c-2-3-5-4-8-4s-6 1-8 4L90 125c-3 3-8 3-12 0-3-3-3-8 0-12L184 8c5-5 12-8 19-8s14 2 19 7l106 106zM316 281c4-3 9-3 12 0 3 4 3 9 0 12L222 399c-5 5-12 7-19 7s-14-2-19-8L78 293c-3-3-3-8 0-12 4-3 9-3 12 0l105 106c2 2 5 3 8 3s6-1 8-3l105-106z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowList);
export default __webpack_public_path__ + "static/media/ShowList.3e10922f334a225b2c85b5dfc49a458f.svg";
export { ForwardRef as ReactComponent };